import { Grid } from "@mui/material";

import {
  ComponentHeader,
  Label,
  PageHeader,
  Paper,
  TextField,
} from "../../../components";

export default function FormOne({ formikProps }) {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <PageHeader pageName={"Profile Details"} pageHeader={"User Details"} />
      </Grid>

      <Grid item xs={12}>
        <Paper gridSpacing={4}>
          <Grid item xs={12}>
            <ComponentHeader title={"Details"} />
          </Grid>

          <Grid item xs={4}>
            <Label title="Display Name" />

            <TextField
              name="displayName"
              placeholder="Display Name"
              disabled
              formikProps={formikProps}
            />
          </Grid>

          <Grid item xs={4}>
            <Label title="Given Name" />

            <TextField
              disabled
              name="givenName"
              placeholder="Given Name"
              formikProps={formikProps}
            />
          </Grid>

          <Grid item xs={4}>
            <Label title="Family Name" />

            <TextField
              disabled
              name="familyName"
              placeholder="Family Name"
              formikProps={formikProps}
            />
          </Grid>

          <Grid item xs={6}>
            <Label title="Email" />

            <TextField
              disabled
              name="email"
              placeholder="Email"
              formikProps={formikProps}
            />
          </Grid>

          <Grid item xs={6}>
            <Label title="Role" />

            <TextField
              placeholder="Role"
              disabled
              name="role"
              formikProps={formikProps}
            />
          </Grid>

          {/* <Grid item xs={12}>
            <Typography
              color={siteColors?.primary}
              variant="caption1"
              style={{ cursor: "pointer" }}
              onClick={() => navigate(pages.changePassword.route)}
            >
              Change Password
            </Typography>
          </Grid> */}
        </Paper>
      </Grid>
    </Grid>
  );
}
